import { Component, OnInit, Input, ElementRef, ContentChild, TemplateRef } from '@angular/core';
import { CfCoreComponent } from '../core/core.component';
import { DatatableColumnModel } from '../../models/datatable/datatable-column.model';
import { DatatableColumnStylingModel } from '../../models/datatable/datatable-column-styling.model';
import { DatatableColumnTemplates } from '../../templates/datatable-column.template';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>CfDatatableColumn component is used to define name and template for each column</p>
 * <pre>
 * <code>
 * <code><</code>cf-datatable-column<code>></code><code><</code><code>/</code>cf-datatable-column<code>></code>
 * </code>
 * </pre>
 */
export class CfDatatableColumnComponent extends CfCoreComponent implements OnInit {
/**
 * Template for column header cell
 */
header;
/**
 * Template for column cell
 */
content;
/**
 * <h4>name: string</h4>
 * Column name
 * <h4>width: string</h4>
 * Column width
 * <h4>headerAlignment: string</h4>
 * Column header cell alignment. Can be: start, center, end. Default: start.
 * <h4>cellAlignment: string</h4>
 * Column row cell alignment. Can be: start, center, end. Default: start.
 * <h4>sortBy: string</h4>
 * Row property name by which rows will be sorted. Default: ''.
 * <p>Example:</p>
 * <pre>{{'{'}}
 * 	name: 'Column name',
 * 	width: '20%',
 * 	headerAlignment: 'end',
 *  cellAlignment: 'start',
 * 	sortBy: 'name'
 * {{'}'}}</pre>
 */
public properties: DatatableColumnModel;
/**
 * <p> dynamicClass: function() -> string,  // Function that returns name of the class </p>
 * <p> class: string                        // Name of the css class selector </p>
 * <p> themeColor: string                   // primary/accent/warn </p>
 * <pre>
 * {{'{'}}
 *  // Container surrounding the all datatable elelemnts
 *  container: {{'{'}} dynamicClass, class {{'}'}},
 *  // Header
 *  header: {{'{'}} dynamicClass, class {{'}'}}
 * }
 * </pre>
 * <p>Example:<p>
 * <pre>
 *  new DatatableColumnStylingModel({{'{'}}
 *    header: {{'{'}}class: 'column-header-class'{{'}'}},
 *    container: {{'{'}}class: 'column-content-class'{{'}'}}
 *  {{'}'}})
 * </pre>
 */
styling: DatatableColumnStylingModel;
/**
 * Name for column
 * @param {?} value
 * @return {?}
 */
set name(value: string) { this.properties.name = value; }
/**
 * Width of column
 * @param {?} value
 * @return {?}
 */
set width(value: string) { this.properties.width = value; }
/**
 * Header alignment. Can be: start, center, end.
 * @param {?} value
 * @return {?}
 */
set headerAlignment(value: string) { this.properties.headerAlignment = value; }
/**
 * Cell alignment. Can be: start, center, end.
 * @param {?} value
 * @return {?}
 */
set cellAlignment(value: string) { this.properties.cellAlignment = value; }
/**
 * Row property name by which rows will be sorted
 * @param {?} value
 * @return {?}
 */
set sortBy(value: string) { this.properties.sortBy = value; }
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(
public elementRef: ElementRef, /**@hidden */ templateService: TemplateService ) {
    super(elementRef, templateService);
    this.properties = new DatatableColumnModel();
    this.styling = new DatatableColumnStylingModel();
  }
/**
 * @hidden 
 * Init all component data
 * @return {?}
 */
ngOnInit() {
    this.getMyTemplate('datatable-column', DatatableColumnTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'DATATABLE-COLUMN').then(sampler => {
        // console.log('DATATABLE-COLUMN', this);
      });
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-datatable-column',
  template: "",
  styles: [""]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'header': [{ type: ContentChild, args: ['header', ] },],
'content': [{ type: ContentChild, args: ['content', ] },],
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'name': [{ type: Input, args: ['name', ] },],
'width': [{ type: Input, args: ['width', ] },],
'headerAlignment': [{ type: Input, args: ['headerAlignment', ] },],
'cellAlignment': [{ type: Input, args: ['cellAlignment', ] },],
'sortBy': [{ type: Input, args: ['sortBy', ] },],
};
}

function CfDatatableColumnComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfDatatableColumnComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfDatatableColumnComponent.ctorParameters;
/** @type {?} */
CfDatatableColumnComponent.propDecorators;
/**
 * Template for column header cell
 * @type {?}
 */
CfDatatableColumnComponent.prototype.header;
/**
 * Template for column cell
 * @type {?}
 */
CfDatatableColumnComponent.prototype.content;
/**
 * <h4>name: string</h4>
 * Column name
 * <h4>width: string</h4>
 * Column width
 * <h4>headerAlignment: string</h4>
 * Column header cell alignment. Can be: start, center, end. Default: start.
 * <h4>cellAlignment: string</h4>
 * Column row cell alignment. Can be: start, center, end. Default: start.
 * <h4>sortBy: string</h4>
 * Row property name by which rows will be sorted. Default: ''.
 * <p>Example:</p>
 * <pre>{{'{'}}
 * 	name: 'Column name',
 * 	width: '20%',
 * 	headerAlignment: 'end',
 *  cellAlignment: 'start',
 * 	sortBy: 'name'
 * {{'}'}}</pre>
 * @type {?}
 */
CfDatatableColumnComponent.prototype.properties;
/**
 * <p> dynamicClass: function() -> string,  // Function that returns name of the class </p>
 * <p> class: string                        // Name of the css class selector </p>
 * <p> themeColor: string                   // primary/accent/warn </p>
 * <pre>
 * {{'{'}}
 *  // Container surrounding the all datatable elelemnts
 *  container: {{'{'}} dynamicClass, class {{'}'}},
 *  // Header
 *  header: {{'{'}} dynamicClass, class {{'}'}}
 * }
 * </pre>
 * <p>Example:<p>
 * <pre>
 *  new DatatableColumnStylingModel({{'{'}}
 *    header: {{'{'}}class: 'column-header-class'{{'}'}},
 *    container: {{'{'}}class: 'column-content-class'{{'}'}}
 *  {{'}'}})
 * </pre>
 * @type {?}
 */
CfDatatableColumnComponent.prototype.styling;
/**
 * @hidden
 * @type {?}
 */
CfDatatableColumnComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
